var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"title":"揉单排序","confirm-loading":_vm.confirmCloseBtnLading},on:{"ok":_vm.handleOk,"cancel":_vm.onClose}},[_c('a-range-picker',{attrs:{"valueFormat":"YYYY-MM-DD","allowClear":""},model:{value:(_vm.closeReason),callback:function ($$v) {_vm.closeReason=$$v},expression:"closeReason"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }